<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Please set LastEditors
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-05-05 11:36:09
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimBalance\viewClaimBalance.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_ClaimBalance_form_viewTitle')"
    pad="0"
    :addBtn="
      (curTab == 'tab-2' ? true : false) &&
      hasBtn('add-admin-claim-transaction')
    "
    @edit="iSEdited = true"
    @new="showNewTran = true"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="transparent d-flex flex-row rounded-lg" elevation="0">
        <!-- left -->
        <v-card
          class="fill-height white rounded-lg pa-0"
          elevation="0"
          width="280"
          :style="{
            minHeight: $vuetify.breakpoint.height - 56 - 78 - 72 - 72 + 'px',
          }"
        >
          <div class="d-flex align-start px-2 py-0">
            <v-autocomplete
              v-model="filterStaffs"
              :items="allStaff"
              filled
              rounded
              ref="filterStaff5"
              height="40"
              dense
              :allow-overflow="false"
              hide-details
              :append-icon="
                filterStaffs.length > 0 && !isFocus
                  ? 'search'
                  : 'arrow_drop_down'
              "
              single-line
              :placeholder="
                $t('label_essweb_leaveBalance_list_staffNameLabel') +
                '/' +
                $t('label_essweb_leaveBalance_list_staffIdLabel')
              "
              @focus="isFocus = true"
              @blur="toFocus"
              chips
              :open-on-clear="false"
              class="py-1 spacial-v-autocomplete"
              multiple
              :filter="$staffFilter"
              item-text="staff_code"
              item-value="staff_id"
              @click:append="
                filterStaffs.length > 0 && !isFocus ? toSearch() : null
              "
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:prepend-item v-if="allStaff.length > 0">
                <v-list-item
                  dense
                  class="px-4"
                  @click="
                    $nextTick(() => {
                      if (filterStaffs.length === allStaff.length) {
                        filterStaffs = [];
                        $refs.filterStaff5.blur();
                        $emit('search', null);
                      } else {
                        $refs.filterStaff5.blur();
                        filterStaffs = [];
                        allStaff.map((item) => {
                          filterStaffs.push(item.staff_id);
                        });
                      }
                    })
                  "
                >
                  <v-list-item-action class="mx-0 my-0 mr-1">
                    <span
                      class="material-icons-round"
                      :class="
                        filterStaffs.length !== 0 &&
                        filterStaffs.length === allStaff.length
                          ? 'primary--text'
                          : filterStaffs.length > 0 &&
                            filterStaffs.length !== allStaff.length
                          ? 'primary--text'
                          : 'text--secondary'
                      "
                    >
                      {{
                        filterStaffs.length !== 0 &&
                        filterStaffs.length === allStaff.length
                          ? "check_box"
                          : filterStaffs.length > 0 &&
                            filterStaffs.length !== allStaff.length
                          ? "indeterminate_check_box"
                          : "check_box_outline_blank"
                      }}
                    </span>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $t("label_essweb_system_select_selectAllLabel")
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  close
                  pill
                  v-if="data.index < 1"
                  class="mx-0 mr-1 pr-2"
                  @click:close="removeStaff(data.item)"
                >
                  <StaffAvatar
                    left
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />

                  <div
                    class="d-inline-block text-truncate"
                    style="max-width: 60px"
                  >
                    {{ $getCommonLangValue(data.item.preferred_name) }}
                  </div>
                </v-chip>
                <span v-if="data.index === 1" class="text--primary py-2">
                  ...
                  {{ filterStaffs.length - 1 }}
                  <!-- {{ $t("label_essweb_selection_moreItemLabel") }} -->
                </span>
              </template>
              <template v-slot:item="data">
                <v-list rounded width="100%" nav>
                  <v-list-item rouned width="100%" nav two-line dense>
                    <v-list-item-avatar class="ma-0 mr-1 white--text" size="36">
                      <StaffAvatar
                        size="36"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2"
                        >{{ $getCommonLangValue(data.item.preferred_name) }}
                        <span class="text--secondary text-caption-xs">{{
                          data.item.staff_code
                        }}</span></v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        $getCommonLangValue(data.item.job_post_name)
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </div>
          <!-- choose -->
          <v-divider></v-divider>
          <noContent v-if="allStaff.length == 0 && !staff_Loading" />
          <v-sheet
            v-if="staff_Loading"
            :style="{
              minHeight:
                $vuetify.breakpoint.height + 24 - 56 - 78 - 72 - 72 - 80 + 'px',
            }"
            class="text-center d-flex align-center justify-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="30"
              width="2"
            ></v-progress-circular>
          </v-sheet>
          <v-list
            dense
            v-if="!staff_Loading"
            :style="{
              maxHeight:
                $vuetify.breakpoint.height + 24 - 56 - 78 - 72 - 72 - 80 + 'px',
            }"
            class="scroll_content_y"
          >
            <v-list-item-group v-model="selectOneStaff" color="primary">
              <v-list-item
                v-for="(staff, index) in show_Staff"
                :key="`staff---${index}`"
                dense
                two-line
                :value="staff.staff_id"
                class="pa-0 px-2 ma-0"
              >
                <v-list-item-avatar size="36" class="pa-0 ma-0 mr-2">
                  <StaffAvatar
                    size="36"
                    :src="staff.staff_avatar"
                    :staff_name="staff.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $getCommonLangValue(staff.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      staff.staff_code
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    {{ $getCommonLangValue(staff.job_post_name) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- left -->
        <v-card
          class="ml-3 rounded-lg flex-grow-1"
          elevation="0"
          :style="{
            maxWidth: 'calc(100% - 292px)',
          }"
        >
          <Taber
            special
            backgroundColor="white"
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
          >
            <template v-slot:content-1>
              <Tabler
                :headers="BalanceHeaders"
                :items="BalanceDeserts"
                :totalCount="totalCount1"
                type="claimbalance"
                @change="
                  (page, perpage, callback) => {
                    getDetail(selectOneStaff, page, perpage, callback);
                  }
                "
              >
                <template v-slot:item.type="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.claim_type_name) }}
                  </div>
                </template>
                <template v-slot:item.currency="{ item }">
                  <div class="text--primary table-title">
                    {{ item.currency_code }}
                  </div>
                </template>
                <template v-slot:item.balance="{ item }">
                  <div class="text--primary table-title">
                    {{ parseFloat(Number(item.claim_balance)) }}
                  </div>
                </template>
                <template v-slot:item.pending="{ item }">
                  <div class="text--primary table-title">
                    {{ parseFloat(Number(item.claim_pending)) }}
                  </div>
                </template>
                <template v-slot:item.f_balance="{ item }">
                  <div class="text--primary table-title">
                    {{ parseFloat(Number(item.claim_future_balance)) }}
                  </div>
                </template>
                <template v-slot:item.action="{ item }"> </template>
              </Tabler>
            </template>
            <template v-slot:content-2>
              <Tabler
                :headers="TransactionHeaders"
                :items="TransactionDeserts"
                type="claimbalance"
                :totalCount="totalCount2"
                @change="
                  (page, perpage, callback) => {
                    getTransaction(selectOneStaff, page, perpage, callback);
                  }
                "
              >
                <template v-slot:item.swift_id="{ item }">
                  <div class="text--primary table-title">
                    {{ item.swift_number }}
                  </div>
                </template>
                <template v-slot:item.type="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.claim_type_name) }}
                  </div>
                </template>
                <template v-slot:item.tr_type="{ item }">
                  <div class="text--primary table-title">
                    {{ $getCommonLangValue(item.claim_transaction_type_name) }}
                  </div>
                </template>
                <template v-slot:item.currency="{ item }">
                  <div class="text--primary table-title">
                    {{ item.currency_code }}
                  </div>
                </template>
                <template v-slot:item.amount="{ item }">
                  <div class="text--primary table-title">
                    {{ parseFloat(Number(item.total_amount)) }}
                  </div>
                </template>
                <template v-slot:item.period="{ item }">
                  <div class="text--primary table-title">
                    {{ item.claim_period }}
                  </div>
                </template>

                <template v-slot:item.status="{ item }">
                  <StatusChip
                    :slideColor="
                      item.status_value == '1'
                        ? 'orange'
                        : item.status_value == '2' ||
                          item.status_value == '3' ||
                          item.status_value == '4'
                        ? 'grey'
                        : item.status_value == '0' ||
                          item.status_value == '5' ||
                          item.status_value == '6'
                        ? 'green'
                        : 'currentColor'
                    "
                  >
                    <template v-slot:status>
                      {{ $getCommonLangValue(item.status_name) }}
                    </template>
                  </StatusChip>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    small
                    icon
                    @click="
                      detailUuid = item.uuid;
                      showViewTran = true;
                    "
                  >
                    <svg-icon
                      size="24"
                      fill="currentColor"
                      iconClass="viewDetail"
                    />
                  </v-btn>
                </template>
              </Tabler>
            </template>
          </Taber>
        </v-card>
      </v-card>
    </template>
    <template v-slot:tools-main>
      <newTransactions
        :show="showNewTran"
        :staff_uuid="selectOneStaff"
        @close="showNewTran = false"
        :curUuid="selectOneStaff"
        @onNew="onNewTransaction"
      />
      <viewTransactions
        :show="showViewTran"
        :staff_uuid="selectOneStaff"
        @close="
          showViewTran = false;
          detailUuid = null;
        "
        :curUuid="selectOneStaff"
        :detailUuid="detailUuid"
      />
    </template>
  </ContentLayout>
</template>
<script>
import newTransactions from "@/Page/EssAdmin/Claim/ClaimBalance/components/newTransactions";
import viewTransactions from "@/Page/EssAdmin/Claim/ClaimBalance/components/viewTransactions";
export default {
  name: "viewClaimBalance",
  components: { newTransactions, viewTransactions },
  computed: {},
  data() {
    return {
      standard_working_minutes: 1,
      filterStaffs: [],
      staff_Loading: false,
      iSEdited: false,
      allStaff: [],
      show_Staff: [],
      selectOneStaff: null,
      selectWillStaff: null,
      isFocus: false,
      totalCount1: 0,
      totalCount2: 0,
      curTab: "tab-1",
      taber: [
        "label_essweb_ClaimBalance_form_tab_BalanceLabel",
        "label_essweb_ClaimBalance_form_tab_Transaction",
      ],
      detailUuid: null,
      showNewTran: false,
      showViewTran: false,
      BalanceHeaders: [
        {
          text: "label_essweb_ClaimBalance_form_claimTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_currencyLabel",
          value: "currency",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_balanceLabel",
          value: "balance",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_pendingLabel",
          value: "pending",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_futureBalanceLabel",
          value: "f_balance",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      BalanceDeserts: [],
      TransactionHeaders: [
        {
          text: "label_essweb_ClaimBalance_form_swiftIdLabel",
          value: "swift_id",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_claimTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_transactionTypeLabel",
          value: "tr_type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_currencyLabel",
          value: "currency",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_amountLabel",
          value: "amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimBalance_form_periodLabel",
          value: "period",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.TransactionDeserts,
              "claim_period",
              desc ? true : false,
              "number"
            ).then((res) => {
              calback(desc);
              this.TransactionDeserts = res;
            });
          },
        },
        {
          text: "label_essweb_ClaimBalance_form_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      TransactionDeserts: [],
    };
  },
  watch: {
    selectOneStaff(val) {
      const that = this;
      this.curTab = "tab-1";
      that.BalanceDeserts = [];
      that.TransactionDeserts = [];
      this.$Sleep(600).then(() => {
        if (val) {
          that.getDetail(val, 1, this.$tableSetting.perPageSize, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        } else {
          // that.BalanceDeserts = [];
          // that.TransactionDeserts = [];
        }
      });
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.staff_Loading = true;
    this.$getStaffList().then((res) => {
      this.allStaff = res;
      this.show_Staff = res;
      this.staff_Loading = false;
    });
    // this.getDetail(1, this.$tableSetting.perPageSize, null);
    // this.getTransaction(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toFocus() {
      const that = this;
      this.$Sleep(300).then(() => {
        that.isFocus = false;
      });
    },
    removeStaff: function (item) {
      this.filterStaffs = this.filterStaffs.filter(
        (ele) => Number(ele) !== Number(item.staff_id)
      );
      if (this.filterStaffs.length == 0) {
        if (this.$refs.filterStaff5) {
          this.$refs.filterStaff5.blur();
        }
      }
    },
    toSearch: function () {
      const that = this;
      // that.$emit("search", that.filterStaffs);
      if (this.$refs.filterStaff5) {
        this.$refs.filterStaff5.blur();
      }
      this.staff_Loading = true;
      this.$Sleep(1000).then(() => {
        if (that.filterStaffs.length <= 0) that.show_Staff = that.allStaff;
        else
          that.show_Staff = that.allStaff.filter(
            (ele) => that.filterStaffs.indexOf(Number(ele["staff_id"])) != -1
          );
        that.staff_Loading = false;
      });
    },
    toNew: function () {},
    toEdit: function (uuid) {},
    getDetail: function (staff, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_balance",
        url: "/claim-balance/get-list/",
        data: {
          staff_uuid: staff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.BalanceDeserts = res.data;
        that.totalCount1 = res.totalcount;
        callback ? callback(page, perpage, null) : null;
      });
    },
    onNewTransaction: function (obj) {
      const that = this;
      this.showNewTran = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_record",
        url: "/claim-transaction-record/add/",
        data: obj,
      }).then((res) => {
        that.getDetail(
          that.selectOneStaff,
          1,
          that.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
        that.getTransaction(
          that.selectOneStaff,
          1,
          that.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
      });
    },
    getTransaction: function (staff, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_record",
        url: "/claim-transaction-record/get-list/",
        data: {
          staff_uuid: staff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.TransactionDeserts = res.data;
        that.totalCount2 = res.totalcount;
        callback ? callback(page, perpage, null) : null;
      });
    },
    toSave: function () {},
  },
};
</script>
